<!--
@component
ReferralBlock

See markup below.
-->

<script lang="ts">
  import { ReferralBlock } from '@reuters-graphics/graphics-components';
  import { appState } from '$lib/stores/index.svelte';
  import { isReutersDev } from '$utils/env';

  interface ReferralContent {
    heading?: string;
    section?: string;
    class?: string;
  }

  interface Props {
    content?: ReferralContent;
  }

  const { content = {} }: Props = $props();

  /* Defaults — used when `content` doesn't supply an override. */
  const DEFAULTS = {
    heading: 'More World Cup coverage',
    section: '/world/europe/',
    class: 'fmy-6',
  } as const;

  const heading = $derived(content.heading ?? DEFAULTS.heading);
  const section = $derived(content.section ?? DEFAULTS.section);
  const className = $derived(content.class ?? DEFAULTS.class);

  const showReferral = $derived(
    appState.isReutersDomain ||
      (appState.currentUrl ? isReutersDev(appState.currentUrl) : false)
  );
</script>

{#if showReferral}
  <ReferralBlock {heading} {section} class={className} />
{/if}
